import TheatreScreen from './TheatreScreen';

export default TheatreScreen;
